import { useRef } from 'react';

export const useThrottle = <T>(cb: (arg: T) => void) => {
  const ref = useRef<NodeJS.Timeout | null>(null);
  return (arg: T) => {
    if (ref.current) clearTimeout(ref.current);
    ref.current = setTimeout(() => {
      clearTimeout(ref.current!);
      cb(arg);
    }, 800);
  };
};
